import { render, staticRenderFns } from "./buchung.vue?vue&type=template&id=034aca2e"
import script from "./buchung.vue?vue&type=script&lang=js"
export * from "./buchung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports